module.exports = __webpack_public_path__ + "img/works-we-love-cn.2799cc0.png";